import React, { useState } from "react";
import { useAuthForm } from "../../context/AuthFormContext";
import Button from "../ui/Button";
import FormError from "../ui/FormError";
import { validateEmail } from "../../utils/validation";

interface PasswordRecoveryRequestViewProps {
	email: string;
}

const PasswordRecoveryRequestView: React.FC<PasswordRecoveryRequestViewProps> = ({ email }) => {
	const { state, requestPasswordReset } = useAuthForm();
	const [formError, setFormError] = useState<string | null>(null);

	const handleSubmit = async (e: React.FormEvent) => {
		e.preventDefault();
		setFormError(null);

		const emailValidation = validateEmail(email);
		if (!emailValidation.valid) {
			setFormError(emailValidation.error!);
			return;
		}

		await requestPasswordReset(email);
	};

	return (
		<div className="auth-view">
			<p className="auth-text-recovery">
				На email <span className="auth-verification-num">{email || "example@mail.com"}</span> будет отправлено письмо со ссылкой для восстановления пароля
			</p>

			<form onSubmit={handleSubmit} className="tw-flex tw-flex-col tw-gap-4">
				<FormError message={formError} />
				<FormError message={state.status === "error" ? state.error : null} />
				{state.status === "success" && <div className="tw-p-3 tw-bg-green-50 tw-text-green-700 tw-rounded tw-text-sm tw-border tw-border-green-200">Письмо отправлено!</div>}

				<Button type="submit" variant="primary" loading={state.status === "submitting"} disabled={state.status === "submitting" || !email} className="tw-w-full">
					{state.status === "submitting" ? "Отправка..." : "Прислать ссылку"}
				</Button>
			</form>
		</div>
	);
};

export default PasswordRecoveryRequestView;
